import { grey, orange } from "@mui/material/colors";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import { getDaysAgo } from "../../../_src_shared/utils/functions/getDaysAgo";
import Flx from "../../layout/Flx";
import ChipItem from "../../ui/ChipItem";

const CellRendererStackedChip = ({ params, icon }) => {
  // console.log("params", params);

  const chipValue = useMemo(() => {
    const val = params?.value;
    if (isNil(val)) {
      return "N/A";
    }
    const daysAgo = getDaysAgo(val);

    if (daysAgo === 0) {
      return "Today";
    }
    if (daysAgo === 1) {
      return " 1d ago";
    }

    return `${daysAgo}d ago`;
  }, [params?.value]);

  return (
    <Flx ac column g={0.8} sx={{ py: 2 }}>
      <span style={{ lineHeight: 1 }}>{params?.valueFormatted}</span>

      <ChipItem
        icon={icon}
        value={chipValue}
        // color={
        //   getDaysAgo(params?.data?.updateDateTime) > 31 ? orange[900] : null
        // }
        // backgroundColor={
        //   getDaysAgo(params?.data?.updateDateTime) > 31 ? orange[50] : grey[100]
        // }
      />
    </Flx>
  );
};

export default CellRendererStackedChip;
